import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useGetProductOverlay, useCheckIsProductOverlay } from 'hooks/product';
import { useGetProductEnums } from 'hooks';

import { useQueryProductHierarchyDetails } from 'pages/product-full-view/queries';

import * as productFullViewSelector from 'pages/product-full-view/controllers/selectors';

import { findDimensionEnumDisplay } from 'pages/product-full-view/mappers/mapToEnums';

/**
 * ! BE require to user original product ID for some api in product full view of a product overlay
 * @returns {number} //? productId to fetch api in PRODUCT FULL VIEW
 */
const useGetToleranceProductId = () => {
  const { id: productId } = useParams();
  const isOverlay = useCheckIsProductOverlay();
  const { originalProductId } = useGetProductOverlay();

  const toleranceProductId = isOverlay ? originalProductId : productId;

  return Number(toleranceProductId);
};

export { useGetToleranceProductId };

/**
 * * get current product hierarchy detail from currentHierarchy on redux
 * @returns
 */
export const useGetCurrentProductHierarchyDetails = () => {
  const currentHierarchy = useSelector(
    productFullViewSelector.makeSelectCurrentHierarchy()
  );

  return useQueryProductHierarchyDetails({
    hierarchyId: currentHierarchy?.productHierarchyId,
  });
};

/**
 * * get measurements for product
 * @param {*} param0
 * @returns
 */
export const useGetProductMeasures = ({ product }) => {
  const { productEnums } = useGetProductEnums();

  const { displayDimensionUOM, displayImperialDimensionUOM } = useMemo(() => {
    let dimensionUOMEnumDisplay;
    let imperialDimensionUOMEnumDisplay;

    if (!!product && !!productEnums) {
      dimensionUOMEnumDisplay = findDimensionEnumDisplay(
        product?.dimensionUOM,
        productEnums
      );
      imperialDimensionUOMEnumDisplay = findDimensionEnumDisplay(
        product?.imperialDimensionUOM,
        productEnums
      );
    }

    return { dimensionUOMEnumDisplay, imperialDimensionUOMEnumDisplay };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(product), productEnums]);

  return {
    imperialHeight: product?.imperialHeight,
    imperialWidth: product?.imperialWidth,
    imperialDepth: product?.imperialDepth,
    imperialLength: product?.imperialLength,
    imperialDimensionUOM:
      displayImperialDimensionUOM || product?.imperialDimensionUOM,
    imperialWeight: product?.imperialWeight,
    imperialWeightUOM:
      findDimensionEnumDisplay(product?.imperialWeightUOM, productEnums) ||
      product?.imperialWeightUOM,
    metricHeight: product?.height,
    metricWidth: product?.width,
    metricDepth: product?.depth,
    metricLength: product?.length,
    metricDimensionUOM: displayDimensionUOM || product?.dimensionUOM,
    metricWeight: product?.weight,
    metricWeightUOM:
      findDimensionEnumDisplay(product?.weightUOM, productEnums) ||
      product?.weightUOM,
  };
};
